export default interface Integration {
  id: string;
  workspaceDomain: string;
  service: "podio" | "hubspot" | "salesforce" | "ghl" | "investorfuse" | "carrot" | "reisift";
  label: string;
  status: string;
  fieldMapping?: Record<string, Record<string, string>>;
  settings?: Record<string, any>;
  lastSyncAt?: string;
  syncDirection?: string;
  syncEnabled?: boolean;
}

export interface SalesforceRealtimeStatus {
  installed: boolean;
  installUrl?: string | null;
  lastEventAt?: string | null;
  checkedAt?: string | null;
}

export interface SalesforceUser {
  id: string;
  name: string;
  email: string;
}

export const SALESFORCE_OBJECT_TYPES = ["LEAD", "CONTACT", "ACCOUNT"] as const;
export type SalesforceObjectType = (typeof SALESFORCE_OBJECT_TYPES)[number];
